import { LogoAndToggle } from './logo-toggle.component';
import { UserMenu } from './user-menu.component';
import { ModuleNavbar } from './module-navbar.component';

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        <LogoAndToggle />
        <div className="collapse navbar-collapse justify-content-end" id="mainNavbar">
          <ul className="navbar-nav md-auto mb-2 mb-lg-0">
            <ModuleNavbar />
          </ul>
          <UserMenu />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
